export const DEFAULT_COUNSELLOR_MODE = 'stage_guided_multiBC';

// The all-tasks implementation and traversal components remain in place as
// dormant scaffolding, but AIMIE does not currently expose them.
export const ALL_TASKS_TRAVERSAL_ENABLED = false;

export const COUNSELLOR_MODES = [
  {
    value: 'volley',
    shortLabel: '6.3A',
    labelKey: 'chat_counsellor_freeform',
    description:
      'This counsellor uses a single response model to reply directly in a natural Motivational Interviewing style. ' +
      'It does not run a separate planning step that explicitly picks techniques before each turn, so it tends to feel the most fluid and conversational. ' +
      'For more detail on how it works, check out the About page.',
  },
  {
    value: 'utterance_multiBC',
    shortLabel: '6.3B',
    labelKey: 'chat_counsellor_technique',
    description:
      'This counsellor adds a planning layer on top of the freeform response model. ' +
      'Before each reply, a separate selector chooses one or two MI behaviour-code strategies from the immediate conversation context, and the counsellor then responds using that guidance. ' +
      'For more detail on how it works, check out the About page.',
  },
  {
    value: 'stage_guided_multiBC',
    shortLabel: 'ME',
    labelKey: 'chat_counsellor_stage',
    description:
      'This counsellor also uses a planning layer, but its selector looks beyond the current exchange. ' +
      'It uses session-stage, change-talk, and progression signals to choose strategies that fit the broader arc of the conversation, making it the most strategically structured option. ' +
      'For more detail on how it works, check out the About page.',
  },
];

export const CLIENT_MODE_COUNSELLOR_OPTIONS = COUNSELLOR_MODES.map(
  ({ value, shortLabel, labelKey }) => ({ value, shortLabel, labelKey })
);

export const isAvailableCounsellorMode = (mode) => (
  COUNSELLOR_MODES.some((entry) => entry.value === mode)
);
